import { Text } from "theme-ui"
import * as styles from "./styles"
import moment from "moment"
import React from "react"

interface DurationProps {
  duration?: number
}

export const Duration: React.FC<DurationProps> = ({ duration }) => {
  const momentDuration = moment.duration(duration, "seconds")
  const durationDays = momentDuration.days()
  const durationHours = momentDuration.hours()
  const durationMinutes = momentDuration.minutes()
  const durationSeconds = momentDuration.seconds()
  return (
    duration && (
      <Text variant="small" sx={styles.root}>
        {durationDays ? <>{durationDays}d, </> : null}
        {durationHours ? <>{durationHours}h, </> : null}
        {durationMinutes ? <>{durationMinutes}m, </> : null}
        {durationSeconds ? <>{durationSeconds}s </> : null}
      </Text>
    )
  )
}
